import React, { useState, useEffect } from 'react'
import { useS4LContext } from '@s4l/react-context'
import { ListOfTopDestination } from '@s4l/stayforlong/marketing/ListOfTopDestination'
import TopDestinations from '..'
import debug from 'debug'

interface ITopDestinationsConnectedProps {
  bannerId: string
}

const log = debug('s4l:uikit:TopDestinationsConnected')

function TopDestinationsConnected(props: Readonly<ITopDestinationsConnectedProps>) {
  const { bannerId } = props

  const { domain } = useS4LContext()
  const [loading, setLoading] = useState(false)
  const [topDestinations, setTopDestinations] = useState<ListOfTopDestination>(
    ListOfTopDestination.empty()
  )

  useEffect(() => {
    if (!bannerId) return

    setLoading(true)
    domain.GetTopDestinationsMarketingUseCase.execute({ bannerId })
      .then(([err, topDest]) => {
        if (err) {
          log('Error getting TopDestinations', err)
          return
        }

        if (!topDest.isEmpty()) {
          setTopDestinations(topDest)
        }
      })
      .catch(err => {
        log('Promise rejected:', err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [bannerId, domain])

  if (!bannerId) return null

  if (loading) return <TopDestinations.Placeholder />

  if (topDestinations.isEmpty() && !loading) return null

  return <TopDestinations topDestinationsJSON={topDestinations.toJSON()} />
}

TopDestinationsConnected.displayName = 'TopDestinationsConnected'
export default TopDestinationsConnected
